module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-10-at-2-23-1@2x-2056247b06b315df42602f385f42da73.png";